<div>
    <div class="mb-3" [hidden]="newFirmwareVisible">
        <div class="mb-3">
            <button class="btn btn-sm btn-primary" (click)="displayNewFirmwareFormGroup()">
                <i class="fas fa-plus-circle"></i> New firmware
            </button>
        </div>
    </div>
    <div class="mb-3 background-hover" [hidden]="!newFirmwareVisible" [formGroup]="newFirmwareFormGroup">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareItemSelect">Item</label>
                    <select class="form-select" id="newFirmwareItemSelect" formControlName="newFirmwareItemSelect">
                        <option *ngFor="let item of items" value="{{ item }}">{{ item }}</option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label>File</label>
                    <div>
                        <input type="file" class="form-control" id="newFirmwareFileInput" (change)="newFirmwareFileInputChange($event)" formControlName="newFirmwareFileInput">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareVersionInput">Version</label>
                    <input type="text" class="form-control" id="newFirmwareVersionInput" placeholder="1.7.54, 2.1.0, 3.0, ..." formControlName="newFirmwareVersionInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareMinVersionInput">Min. Required (optional)</label>
                    <input type="text" class="form-control" id="newFirmwareMinVersionInput" placeholder="1.7.54, 2.1.0, 3.0, ..." formControlName="newFirmwareMinVersionInput">
                </div>
            </div>
        </div>
        <div class="mb-3 row gx-1">
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" [disabled]="newFirmwareFormGroup.invalid" (click)="uploadNewFirmware()">
                    <i class="fas fa-cloud-upload-alt"></i> Upload
                </button>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-secondary" (click)="hideNewFirmwareFormGroup()">
                    <i class="fas fa-ban"></i> Cancel
                </button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="lastFirmwaresForTestUsers || lastFirmwaresForBetaUsers || lastFirmwaresForEndUsers">
    <h4>Last firmwares</h4>
    <div *ngIf="lastFirmwaresForTestUsers">
        <h5>For admin and test users</h5>
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Item</th>
                    <th scope="col">Version</th>
                    <th scope="col"><span class="text-muted">Min. Required</span></th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of lastFirmwaresForTestUsers.firmwares">
                    <td scope="row">
                        {{ firmware.item }}
                    </td>
                    <td>
                        {{ firmware.version }}
                    </td>
                    <td>
                        <span class="text-muted">{{ firmware.minVersion ? firmware.minVersion : '-' }}</span>
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.filename">
                            <i class="fas fa-download"></i> {{ firmware.filename }}
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishedTime : firmware.uploadedTime) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'UPLOADED'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-warning" *ngIf="firmware.status == 'UPLOADED'" (click)="toValidateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> To Validate
                        </a>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td>
                        <a [href]="lastFirmwaresForTestUsers.globalUrl" *ngIf="lastFirmwaresForTestUsers.globalUrl">
                            <i class="fas fa-download"></i> *.zip
                        </a>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div *ngIf="lastFirmwaresForBetaUsers">
        <h5>For beta users</h5>
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Item</th>
                    <th scope="col">Version</th>
                    <th scope="col"><span class="text-muted">Min. Required</span></th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of lastFirmwaresForBetaUsers.firmwares">
                    <td scope="row">
                        {{ firmware.item }}
                    </td>
                    <td>
                        {{ firmware.version }}
                    </td>
                    <td>
                        <span class="text-muted">{{ firmware.minVersion ? firmware.minVersion : '-' }}</span>
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.filename">
                            <i class="fas fa-download"></i> {{ firmware.filename }}
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishedTime : firmware.uploadedTime) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'UPLOADED'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-warning" *ngIf="firmware.status == 'UPLOADED'" (click)="toValidateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> To Validate
                        </a>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td>
                        <a [href]="lastFirmwaresForBetaUsers.globalUrl" *ngIf="lastFirmwaresForBetaUsers.globalUrl">
                            <i class="fas fa-download"></i> *.zip
                        </a>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div *ngIf="lastFirmwaresForEndUsers">
        <h5>For end users</h5>
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Item</th>
                    <th scope="col">Version</th>
                    <th scope="col"><span class="text-muted">Min. Required</span></th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of lastFirmwaresForEndUsers.firmwares">
                    <td scope="row">
                        {{ firmware.item }}
                    </td>
                    <td>
                        {{ firmware.version }}
                    </td>
                    <td>
                        <span class="text-muted">{{ firmware.minVersion ? firmware.minVersion : '-' }}</span>
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.filename">
                            <i class="fas fa-download"></i> {{ firmware.filename }}
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishedTime : firmware.uploadedTime) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'UPLOADED'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-warning" *ngIf="firmware.status == 'UPLOADED'" (click)="toValidateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> To Validate
                        </a>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td>
                        <a [href]="lastFirmwaresForEndUsers.globalUrl" *ngIf="lastFirmwaresForEndUsers.globalUrl">
                            <i class="fas fa-download"></i> *.zip
                        </a>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
<div *ngIf="firmwares && firmwares.length > 0">
    <h4>Configure firmwares</h4>
    <div class="mb-3 background-hover" *ngIf="selectedFirmwareToEdit" [formGroup]="editFirmwareFormGroup">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareItemInput">Item</label>
                    <select class="form-select" id="editFirmwareItemInput" formControlName="editFirmwareItemInput">
                        <option *ngFor="let item of items" value="{{ item }}">{{ item }}</option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareFileInput">File</label>
                    <input type="text" class="form-control" id="editFirmwareFileInput" formControlName="editFirmwareFileInput">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareVersionInput">Version</label>
                    <input type="text" class="form-control" id="editFirmwareVersionInput" placeholder="1.7.54, 2.1.0, 3.0, ..." formControlName="editFirmwareVersionInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareMinVersionInput">Min. Required (optional)</label>
                    <input type="text" class="form-control" id="editFirmwareMinVersionInput" placeholder="1.7.54, 2.1.0, 3.0, ..." formControlName="editFirmwareMinVersionInput">
                </div>
            </div>
        </div>
        <div class="mb-3 row gx-1">
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" [disabled]="editFirmwareFormGroup?.invalid" (click)="updateSelectedFirmwareToEdit()">
                    <i class="fas fa-save"></i> Save
                </button>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-secondary" (click)="cancelSelectedFirmwareToEdit()">
                    <i class="fas fa-ban"></i> Cancel
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="!selectedFirmwareToEdit">
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Item</th>
                    <th scope="col">Version</th>
                    <th scope="col"><span class="text-muted">Min. Required</span></th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of firmwares">
                    <td scope="row">
                        {{ firmware.item }}
                    </td>
                    <td>
                        {{ firmware.version }}
                    </td>
                    <td>
                        <span class="text-muted">{{ firmware.minVersion ? firmware.minVersion : '-' }}</span>
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.filename">
                            <i class="fas fa-download"></i> {{ firmware.filename }}
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishedTime : firmware.uploadedTime) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'UPLOADED'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-warning" *ngIf="firmware.status == 'UPLOADED'" (click)="toValidateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> To Validate
                        </a>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-primary" *ngIf="(firmware.status == 'UPLOADED' || firmware.status == 'TO_VALIDATE')" (click)="displaySelectedFirmwareToEdit(firmware.id)">
                            <i class="fas fa-edit"></i> Edit
                        </a>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-danger" (click)="displayDeleteFirmware(firmware.id)" *ngIf="!deleteFirmwareVisibles[firmware.id]">
                            <i class="fas fa-trash-alt"></i> Delete
                        </a>
                        <a href="javascript:void(0)" class="text-danger" (click)="deleteFirmware(firmware.id)" *ngIf="deleteFirmwareVisibles[firmware.id]">
                            <i class="fas fa-exclamation-circle"></i> Confirm
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>